import stylex from '@stylexjs/stylex';
export const buttonBaseStyles = stylex.create({
    host: {
        display: 'inline-flex',
        position: 'relative',
        cursor: 'pointer',
        userSelect: 'none',
        textDecoration: 'none',
    },
    host$disabled: {
        cursor: 'default',
        pointerEvents: 'none',
    },
    background: {
        position: 'absolute',
        inset: 0,
        borderRadius: 'inherit',
        pointerEvents: 'none',
    },
    background$disabled: {},
    outline: {
        position: 'absolute',
        inset: 0,
        borderRadius: 'inherit',
        pointerEvents: 'none',
    },
    outline$disabled: {},
});
